export default __webpack_public_path__ + "static/media/camera.7199348f.svg";